module.exports = __webpack_public_path__ + "static/bamboo-left-678e2633a0f48d3c9599a562bbdf2b26.png";